import axios from "axios";
import { errorToast } from "./toast";

export const sendEmail = async (emailData) => {
  const apiKey = process.env.REACT_APP_BREVO_API_KEY;
  const url = 'https://api.brevo.com/v3/smtp/email';
  // console.log("📤 Sending email to Brevo...");

  try {
    const response = await axios.post(url, emailData, {
      headers: {
        'Content-Type': 'application/json',
        'api-key': apiKey,
      },
    });
    // console.log("✅ Brevo response:", response.data);
    return response.data;
  } catch (error) {
    // console.error("❌ Brevo error:", error.response?.data || error.message);
    errorToast(
      'Email send failed!',
      error.response?.data?.message || error.message
    );
  }
};